import React from 'react'
import { connect } from 'react-redux'
import { actionCreators } from '@/store/Menu'
import Icon from '@/components/Icon'
import NavItem from './NavItem'
import { Nav, Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap'
import Resx from '@/components/Resx'
import LanguageSwitch from '@/components/LanguageSwitch'
import { Scrollbar } from '@/components/scrollbar'

let MainMenu = React.memo(({ topItems, items, activePath, openPath, isNavSmall, compactToggle, setActiveItem, setOpenItem, permissions }) => {
  // search for denied items
  const deniedItems = items.filter(x => x.permission && (
    Array.isArray(x.permission)
      ? !x.permission.find(p => permissions.indexOf(p) >= 0)
      : permissions.indexOf(x.permission) < 0))
  // filter out all denied items and all empty folder items
  items = filterOutDeniedItems(items, deniedItems)

  function handleMenuItemClick (e, id, isOpen) {
    setOpenItem(!isOpen ? id : null)
  }

  function onNavigate (itemId) {
    setActiveItem(itemId)
  }

  function renderItems (subItems) {
    return subItems.map(item => {
      const active = activePath.indexOf(item.id) >= 0 ? 'active' : ''
      const isOpen = openPath.length > 0 ? openPath.indexOf(item.id) >= 0 : openPath.indexOf(item.id) >= 0
      return item.hasChildren
        ? (
          <Dropdown key={item.id} direction='right' isOpen={isOpen} toggle={(e) => openPath.length > 0 && handleMenuItemClick(e, item.id, isOpen)}
            className={active}>
            <DropdownToggle nav onClick={(e) => handleMenuItemClick(e, item.id, isOpen)}>
              <Icon name={item.icon} />
              <span><Resx name={item.text} /></span>
            </DropdownToggle>

            <DropdownMenu modifiers={{ preventOverflow: { boundariesElement: 'viewport' } }} positionFixed persist>
              {renderItems(items.filter(x => x.parentId === item.id))}
            </DropdownMenu>
          </Dropdown>
        ) : (
          <NavItem key={item.id} to={item.path} active={!!active} className={item.className} target={item.target} onClick={() => onNavigate(item.id)}>
            {item.icon ? <Icon name={item.icon} /> : null}
            <span>
              {typeof item.text === 'function' ? item.text() : <Resx name={item.text} />}
            </span>
          </NavItem>
        )
    }
    )
  }
  return (
    <React.Fragment>
      <div className='navbar-nav--first'>
        <Scrollbar>
          {typeof topItems === 'object' ? renderItems(topItems) : null}
          {renderItems(items.filter(x => !x.parentId))}
        </Scrollbar>
      </div>
      <Nav className='navbar-nav--last' navbar>
        <li className='nav-item nav__switcher'>
          <button className='nav-link' onClick={compactToggle}>
            <Icon name={isNavSmall ? 'menu' : 'arrow-back'} />
          </button>
        </li>
        <li className='nav-item nav-item--language'>
          <LanguageSwitch />
        </li>
      </Nav>
    </React.Fragment>
  )
})

function filterOutDeniedItems (items, deniedItems) {
  const hiddenItems = [...deniedItems]
  function _filterOutDeniedItems (hiddenItem) {
    if (hiddenItem.parentId) {
      const anySibling = !!items.find(x => x.parentId === hiddenItem.parentId && hiddenItems.indexOf(x) < 0)
      if (!anySibling) {
        // when parent has no permitted items, add it to deniedItems and continue with parent
        const parent = items.find(x => x.id === hiddenItem.parentId)
        hiddenItems.push(parent)
        _filterOutDeniedItems(parent)
      }
    }
  }

  for (let i = 0; i < deniedItems.length; i++) {
    _filterOutDeniedItems(deniedItems[i])
  }
  return items.filter(x => hiddenItems.indexOf(x) < 0)
}

function mapStateToProps (state) {
  return { ...state.menu, permissions: state.permissions.granted }
}

const mapDispatchToProps = {
  setActiveItem: actionCreators.setActiveItem,
  setOpenItem: actionCreators.setOpenItem,
  compactToggle: actionCreators.compactToggle
}

MainMenu = connect(mapStateToProps, mapDispatchToProps)(MainMenu)

export {
  MainMenu
}



// WEBPACK FOOTER //
// ./src/components/Layout/MainMenu.js